import React, { useEffect, useRef, useState } from "react";
import { SelectPayment } from "./SelectPayment/SelectPayment";
import { VerifyInformation } from "./VerifyInformation/VerifyInformation";
import { ConfirmationPage } from "./ConfirmationPage/ConfirmationPage";
import { Box, Typography, Backdrop } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import "./index.scss";
import { getquickBillPayPageContent } from "../../../../../SharedContextStore/slices/contents/qbpContentAem";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import NotificationBannerView from "../../../../../SharedComponents/notificationBannerView";
import { EC_DW_LOGGING_STEPS } from "../../../../../../../shared/utils/Constants";
import DwLogutil from "../../../../../Utils/DwLogutil";
import { useCustomNavigate } from "../../../../../Utils/navigationUtils";
import { QuickBillPay } from "../../../../../SharedComponents/contents";
import BannerComponent from "../../../../../Utils/newBannerComp";
import { addEneventGTM } from "../../../../../Utils/googleTags";
import useBrightspeedHeaders from "../../../../../hooks/useBrightspeedHeader";
import ALLURLS from "../../../../../Utils/axr";
import { getBrightspeedToken, resetToken, setHeaders } from "../../../../../SharedContextStore/slices/brightspeedToken";
import { getAzureInfo } from "../../../../../../../shared/hooks/useFetchLogin";
import { startLoading, stopLoading } from "../../../../../SharedContextStore/slices/user";

/**HANDLE THE FLOW OF QUICK BILL PAYMENT BY USING BOOL STATES PROPS OF THE CURRENT STEPS */


interface QBPIndexProps {
  QBP_ON?: boolean;
  nonAuth?: boolean;
}
export const QBPIndex = (props: QBPIndexProps) => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { customNavigate } = useCustomNavigate();
  const QBP_CONTENT_2: any = QuickBillPay();
  const QBP_CONTENT_Data: any = useAppSelector(
    (state) => state.quickBillPayContent?.quickBillPayPageContent
  );
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const loading = useAppSelector((state) => state?.user?.loading);
  const params = new URLSearchParams(window.location.search);
  const codeFromUrl = params.get("code");
  const fetchIdCalledRef = useRef(false);
  const agentTokenFetchedRef = useRef(false);
  const headers = useBrightspeedHeaders();

  useEffect(() => {
    if(!QBP_CONTENT_Data) {
    dispatch(getquickBillPayPageContent());
    }
  }, []);

  useEffect(() => {

    const fetchData = async () => {
      const isAgentQbpRoute = location.pathname?.includes('agent-quick-bill-pay');
      
      // Re-trigger token fetch for agent-quick-bill-pay route (only once), or if no token exists
      if (isAgentQbpRoute && !agentTokenFetchedRef.current) {
        agentTokenFetchedRef.current = true;
        dispatch(resetToken()); // Clear cached token to force fresh API call
        await getBrightSpeedTokenSync();
      } else if (!globalToken?.access_token) {
        await getBrightSpeedTokenSync();
      }

      if (codeFromUrl && fetchIdCalledRef.current === false) {
        fetchIdCalledRef.current = true;
        await AzureADCallOnLoad(codeFromUrl);
      }
    };
    fetchData();
  }, [globalToken, codeFromUrl, location.pathname]);

  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [paymentType, setPaymentType] = useState<any>("");
  const [paymentCardInfo, setCardInfo] = useState<any>({});
  const [currentAmount, setCurrentAmount] = useState<any>(0);
  const [billAmount, setBillAmount] = useState<any>(null);
  const [showEditInfo, setShowEditInfo] = useState<Boolean>(false);
  const [qbpSuccessCode, setQbpSuccessCode] = useState<string>("");
  const [retainformData, setRetainFormDate] = useState<any>({})
   const { companyName, data: user, sessionId } = useAppSelector((state) => ({
      companyName: state?.user?.companyName,
      data: state?.user?.data,
      sessionId: state?.user?.sessionId,
    }));

  const AzureADCallOnLoad = async (codeFromUrl: any) => {
    try {
      dispatch(startLoading());
      const fetchIDRes = await getAzcallB2C(codeFromUrl);
      if (!fetchIDRes || fetchIDRes === "User details not found") {
         dispatch(stopLoading());
        return;
      }
    } catch (error: any) {
      console.error(error);
      dispatch(stopLoading());
    }
  };

  const getAzcallB2C = async (codeFromUrl: any) => {
    try {
      let url = ALLURLS['fetchID'];
      const response = await getAzureInfo({ "": url }, {
        ...headers,
        acode: codeFromUrl,
        flowType: "qbp",
      });
      const apiData = response?.data;
      dispatch(setHeaders({
        ...headers,
        "access-token": response?.data?.token,
        acode: codeFromUrl,
        "nonce":""
      }));
      dispatch(stopLoading());
      return apiData;
    } catch (error: any) {
      console.error(error);
    }
  };

  const getBrightSpeedTokenSync = async () => {
    await dispatch(getBrightspeedToken("qbp"));
  };

  const LoadStep0 = (
    confirmation: boolean,
    paymentType: any,
    cardInfo: any,
    amount: any,
    isEdit: Boolean
  ) => {
    if (confirmation) {
      setStep2(false);
      setPaymentType(paymentType);
      setCardInfo(cardInfo);
      setCurrentAmount(amount);
      setStep1(true);
      setShowEditInfo(isEdit);
    } else {
      setStep2(false);
      setStep1(true);
      setPaymentType(paymentType);
      setCardInfo(cardInfo);
      setCurrentAmount(amount);
    }
  };
  const LoadStep1 = (
    confirmation: boolean,
    paymentType: any,
    cardInfo: any,
    amount: any
  ) => {
    if (confirmation) {
      setStep2(true);
      setPaymentType(paymentType);
      setCardInfo(cardInfo);
      setCurrentAmount(amount);
      setStep1(false);
    }
  };
  const LoadStep2 = (confirmation: boolean) => {
    if (confirmation) {
      setStep3(true);
      setStep2(false);
      setStep1(false);
    }
  };
  const LoadStep3 = (
    confirmation: boolean,
    paymentType: any,
    cardInfo: any,
    amount: any,
    bill: number,
    successCode: string
  ) => {
    if (confirmation) {
      setStep3(true);
      setPaymentType(paymentType);
      setCardInfo(cardInfo);
      setCurrentAmount(amount);
      setBillAmount(bill);
      setStep2(false);
      setStep1(false);
      setQbpSuccessCode(successCode);
    }
  };
  const retainformDataOnRevisit = (data:any) => {
    setRetainFormDate(data)
  }

  const {
    qbp_back_step1,
    qbp_back_step2,
    unauthqbp_back_step1,
    unauthqbp_back_step2,
  } = EC_DW_LOGGING_STEPS

  return (
    <Box className="QBPBox">
      {/* {step1 && (<NotificationBannerView
           iconType="info"  
        />)} */}
      {step1 && (<BannerComponent
           iconType="info"  
        />)}
      {!step3 ? (
        <div>
          <Typography
            variant="h1"
            color="initial"
            className="titleQuickBillPay"
            sx={{ marginTop: 4, marginBottom: 4,marginLeft: 3 }}
          >
            { 'Quick Bill Pay'}
          </Typography>
          {/* <Typography variant="body1" color="initial" sx={{ marginBottom: 4 }} component="button"
          role="link"
          
              className="BackPaymentTitle btnText p-0"
              onClick={() => {
                if (props?.nonAuth && step1) {
                  return customNavigate('/non-auth-quick-bill-pay');
                }
                if (!step1) {
                  setStep1(true);
                  setStep2(false);
                  setStep3(false);
                  if (props?.nonAuth) {
                    DwLogutil({
                      stepName: unauthqbp_back_step2
                    })
                    addEneventGTM(
                      unauthqbp_back_step2,
                      sessionId,
                      user?.billingAccountNumber,
                      companyName
                    )
                  }
                  else {
                    DwLogutil({
                      stepName: qbp_back_step2,
                      flowType: user?.currentStatus
                    });
                    addEneventGTM(
                      qbp_back_step2,
                      sessionId,
                      user?.billingAccountNumber,
                      companyName
                    )
                  }
                }
                if (step1) {
                  navigation("/my-bills/view-payments");
                  setStep1(false);
                  setStep2(false);
                  setStep3(false);
                  if(props?.nonAuth){ 
                     DwLogutil({
                        stepName: unauthqbp_back_step1
                      })
                      addEneventGTM(
                      unauthqbp_back_step1,
                      sessionId,
                      user?.billingAccountNumber,
                      companyName
                    )
                    }
                    else{ 
                      DwLogutil({
                        stepName: qbp_back_step1,
                        flowType: user?.currentStatus
                      });
                      addEneventGTM(
                      qbp_back_step1,
                      sessionId,
                      user?.billingAccountNumber,
                      companyName
                    )
                    }
                }
              }}
            >
              <svg
                className="returnIcon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path d="M15 16L6 8.5L15 1" stroke="black" strokeWidth="2" />
              </svg>
              {
                QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                  ?.back_link_label
              }
          
          </Typography> */}
        </div>
      ) : (
        ""
      )}
      {step1 
        && <SelectPayment 
            activeStep2={LoadStep1} 
            chosenPayMethod={paymentType} 
            openEditChosenPayMethod={showEditInfo} 
            editItem={paymentCardInfo}
            QBP_ON={props?.QBP_ON}
            isUnAuthQbp={props?.nonAuth}
            unAuthCardInfo={setCardInfo}
            currentAmount={currentAmount} 
            retainformDataOnRevisit={retainformDataOnRevisit} 
            retainformData={retainformData} 
          /> 
      }
      {step2
        && <VerifyInformation
            activeStep1={LoadStep0}
            activeStep3={LoadStep3}
            selectedPaymentCard={paymentType}
            cardInformation={paymentCardInfo}
            amount={currentAmount}
            QBP_ON={props?.QBP_ON}
            isUnAuthQbp={props?.nonAuth} 
          />
      }
      {
        <Backdrop className="custom-loader-backdrop" open={loading}>
          <div className="custom-loader"></div>
        </Backdrop>}
      {step3 
        && <ConfirmationPage
            activeStep3={LoadStep3}
            selectedPaymentCard={paymentType}
            cardInformation={paymentCardInfo}
            amount={currentAmount}
            billPayment={billAmount}
            qbpSuccessCode={qbpSuccessCode}
            QBP_ON={props?.QBP_ON}
            isUnAuthQbp={props?.nonAuth} 
          />
      }
    </Box>
  );
};